import { FC, useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { validate } from "capitalrx-components-2.0";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { Question } from "capitalrx-types";
import { Checkbox, Textbox } from "capitalrx-components-2.0/lib/forms";

import { ANSWER_NOT_AVAILABLE } from "@/utils";

import { QuestionWrapper, QuestionnaireWrapperProps } from "./QuestionWrapper";

interface Props extends QuestionnaireWrapperProps {
  readonly inputLabel: string;
  readonly inputRequired?: boolean;
  readonly placeholder?: string;
  readonly next?: Question["next"];
}

export const InputNumber: FC<Props> = ({
  inputLabel,
  inputRequired,
  disabled = false,
  name,
  placeholder = "Enter A Number",
  isReadonly = false,
  debugMode = false,
  next,
  ...rest
}) => {

  const { setValue } = useFormContext();

  const [value, notAvailable] = useWatch({
    name: [`${name}_value`, `${name}_not_available`],
  });

  useEffect(() => {
    const inputValue = notAvailable ? ANSWER_NOT_AVAILABLE : value;
    setValue(name, inputValue);
  }, [value, notAvailable, setValue, name]);

  return (
    <QuestionWrapper
      disabled={disabled}
      isReadonly={isReadonly}
      name={name}
      debugMode={debugMode}
      hideClearSelection
      {...rest}
    >
      <Textbox.Field
        name={`${name}_value`}
        label={inputLabel}
        required={inputRequired}
        disabled={disabled || notAvailable}
        placeholder={placeholder}
        readOnly={isReadonly}
        validator={validate.isNumeric}
        hideLabel={!inputLabel}
      />

      {debugMode && <Paragraph>{next ? JSON.stringify(next) : "not-specified"}</Paragraph>}

      <Checkbox.Field
        name={`${name}_not_available`}
        label="Answer not available"
        disabled={disabled}
        readOnly={isReadonly}
        hideLabel
      />
    </QuestionWrapper>
  );
};
